<template>
    <div class="step-content-lint-text" v-if="step">
        <div class='step-content-line-step3'>
            <p class='text'>
                <md-card class="mkt-card-step3" v-for="(item , index) in value.sets" v-bind:key="index" style="border: 1px solid #EFEFEF;padding: 6px 6px 6px 12px;">
                    <span v-if="(item.name == '')" class="name-set-step3">SET {{index+1}}</span>
                    <span v-else class="name-set-step3 kanitfont">{{item.name}}</span>
                    <!-- <span class="title-condition-step3">Name</span><span> {{item.name}} </span> -->
                    <div v-if="item.conditions.length > 0" v-for="(item1 , index1) in item.conditions" v-bind:key="`A-${index1}`" >
                        <span class="title-condition-step3">Condition</span><span> {{item1.type}}: </span>
                        <span v-html="(!item1.max_level)?`${item1.min * 1} to ${item1.max * 1}`: `${item1.min * 1} to Max`"></span>
                    </div>
                    <div v-if="item.promotions.length > 0" v-for="(item2 , index2) in item.promotions" v-bind:key="`B-${index2}`" >
                        <span v-if="index2 == 0" class="title-promotion-step3" style="display: unset;" v-html="'Promotion '"></span>
                        <span v-if="item2.type !== 'Free item'" v-html="(item2.type === 'Discount')?`${item2.type}: ${item2.value * 1} %`:`${item2.type}: ${item2.value * 1} Baht`"></span>
                        <span v-else v-html="`${item2.type} ${item2.value.length} Products`"></span>
                    </div>
                </md-card>
            </p>
        </div>
    </div>
    <div class="step-content-lint-text" v-else>
        <div class='step-content-line-step3'>
            <p class='text'>Build you set of pricing and promotion conditions</p>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'step-3-data',
        computed: {
            value() {
                return this.$store.getters['pmcreate/value']
            },
            step() {
                if(this.$store.getters['pmcreate/step'] == 'step-3' || this.$store.getters['pmcreate/statusAction'] == 'edit'){
                    return true
                }else{
                    return false
                }
            }
        },
    }
</script>
